export enum RangeType {
  BHN = 'bhn',
  FBN = 'fbn',
  FCN = 'fcn',
  FHN = 'fhn',
  FHNW = 'fhnw',
  CCN = 'ccn',
  SHNW = 'shnw',
  SHN = 'shn',
  VHN = 'vhn',
}
